
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {  ActivatedRoute, Router } from '@angular/router';
import { Subscription, take } from 'rxjs';
import { EventsConstants } from '../../../../commons/constants/event-constants';
import { LoginModel } from '../../models/login-model';
import { AuthService } from '../../services/auth.service';
import { CountriesConstants } from '../../../../commons/constants/countries-constant';
import { CountryModel } from '../../../../commons/models/country-model';
import { CountryService } from '../../../../commons/services/country.service';
import { CountriesEnum } from '../../../../commons/enums/countries.enum';
import { BaseTranslateService } from '../../../../commons/services/base-translate.service';
import { environment } from '../../../../../environments/environment';
import * as CryptoJS from 'crypto-js';
import { TranslatedTextKey } from '../../contants/translate-key.constants';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { GlobalConstants } from '../../../../commons/constants/global-constants';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GetFederatedTokenModel } from '../../models/auth-federated-token-model';
import { LoginResponseModel } from '../../models/login-response.model';
import { ProgreesBarService } from '../../../../commons/services/progrees-bar.service';
import { AppState } from '../../../../app.state';
import { Store, select } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { ROUTER_LOGIN } from '../../../../commons/constants/router/router.constant';
import { UserGraphQLService } from '../../../../graphQL/services/user/userGraphQL.service';
import { SharedFormValidationsService } from 'src/app/commons/services/sharedFormValidations.service';
import { selectGenericForms } from 'src/app/commons/constants/store/parameters.selector';
import { TranslateService } from '@ngx-translate/core';




// export function HttpLoaderFactory(httpClient: HttpClient) {
//   return new TranslateHttpLoader(httpClient, '/assets/i18n/', '.json');
// }
@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})


export class CreateAccountComponent implements OnInit, OnDestroy {
  public form=new FormGroup({
    username: new FormControl("", [Validators.required, this.validEmail]),
    password: new FormControl("", [Validators.required])
  });
  urlRedirect: string = '';
  public countries: CountryModel[] = CountriesConstants;
  public showPassword: boolean = false;
  private _authSubscription: Subscription = new Subscription;
  private _onChangeLanguage: Subscription = new Subscription;
  translatedTextKeyLogin = TranslatedTextKey;
  backgroundImage= environment.backgroundImage
  storeLogo: string = '';
  authCode: string = '';
  state: any = null;
  constructor(
    private store: Store<AppState>,
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _countryService: CountryService,
    public _baseTranslateService: BaseTranslateService,
    private _recaptchaV3Service: ReCaptchaV3Service,
    private progreesBarService:ProgreesBarService,
    private messageService: MessageService,
    private router: Router,
    private _userService: UserGraphQLService,
     public _sharedFormValidationsService: SharedFormValidationsService,
     private translate: TranslateService,
  ) {

    this._activatedRoute.queryParams.subscribe(
      (params) => {
        if (params["urlRedirect"] !== null && params["urlRedirect"] !== undefined && params["urlRedirect"] !== "") {
          this.urlRedirect = params["urlRedirect"];
        }
        if (params['code'] !== null && params['code'] !== undefined && params['code'] !== "") {
          this.federatedLogin(params['code']);

        }
      }

    );



    this.resetForm();
  }

providers: any[] = [];
  getStoreConfig(){
    this._userService.getStoreConfig(environment.storeIdComplete).subscribe({
      next: (data: any) => {

          this._userService.storeConfig = data.getStoreInfo;

      if (data.getStoreInfo?.authProviders) {
        this.providers = data.getStoreInfo.authProviders.filter((p: any) => p.isEnabled);
      }
          this.progreesBarService.hideProgressBar();

      },


    });

  }
  phonevalidators:any;

  ngOnInit(): void {
    this.getStoreConfig();
    this.store.select((state) => state).subscribe(state => {
      this.state = state;
    });




  }

  ngOnDestroy(): void {
    this._authSubscription?.unsubscribe();
    this._onChangeLanguage?.unsubscribe();
  }

  public onSelectedCountry(): void {
    const countryId: string = this.form.get("country")!.value;
    if (countryId === CountriesEnum.Usa) {
      this._baseTranslateService.setLangEn();
    } else {
      this._baseTranslateService.setLangEs();
    }
  }

  public onSubmit(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    let login = new LoginModel();
    let replaceUserName=this.form.controls['username'].value!.replace(/\s/g, "");
    let replacePassword= this.form.controls['password'].value!.replace(/\s/g, "");
    login.username = replaceUserName;
    login.password =this.encrypt(replacePassword);
    login.country = "5"
    this.getToken(login);
  }

  public handleKeyUp(e: { keyCode: number; }): void {
    if (e.keyCode === 13) {
      this.onSubmit();
    }
  }

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }

  private getToken(login: LoginModel): void {
    this.progreesBarService.showProgressBar();
    this._recaptchaV3Service.execute(GlobalConstants.Login).subscribe({
      next: (token) => {
      login.captchaToken=token;
        this._authSubscription = this._authService.internalLogin(login).subscribe({
          next: (response) => {
            this.progreesBarService.hideProgressBar();
            if (response?.data?.access_token&&response?.data?.access_token!=="") {

              this.processTokenSuccessResponse(response.data, login.country)
            }
            else
            {
              this.messageService.add({ severity: 'error', detail: this._baseTranslateService.getText(TranslatedTextKey.INVALID_USERNAME_OR_PASSWORD) });
            }
          },
          error: (response: string) => {
            this.progreesBarService.hideProgressBar();
            // let errormessage=this._baseTranslateService.getText(TranslatedTextKey.ERROR_MESSAGE500)
            let errormessage=this.translate.instant('mcfLoginShell.errorMessages.errorMessage500').toString()
            if(TranslatedTextKey.hasOwnProperty(response))
            {
              let key = (TranslatedTextKey as { [key: string]: any })[response] as string;
              errormessage = this.translate.instant(key).toString();
            }
            this.messageService.add({ severity: 'error', detail: errormessage });
          }
        });

    },
    error: (err) => {
      this.progreesBarService.hideProgressBar();
      this.messageService.add({ severity: 'error', detail: this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString() });
    }
  });
  }
  private processTokenSuccessResponse( loginResponseModel: LoginResponseModel, country: string): void {
    this._countryService.setCountryId(country);
    if (this.urlRedirect === '') {

      this.urlRedirect = environment.DefaultRedirect;

    }
            window.location.href = this.urlRedirect+"?idToken="+loginResponseModel.access_token+"&refreshToken="+loginResponseModel.refresh_token;

  }
  private resetForm(): void {
    this.form = new FormGroup({
      username: new FormControl("", [Validators.required, this.validEmail]),
      password: new FormControl("", [Validators.required])
    });
  }


  private showErrorMessage(errorMessage: string = "") {
    this.progreesBarService.hideProgressBar();
    window.dispatchEvent(new CustomEvent(EventsConstants.SHOW_ERROR, {
      detail: errorMessage ? errorMessage : "Error"
    })
  );
  }

  public validEmail(control: FormControl) : { [key: string]: boolean } {
    const nameRegexp: RegExp = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
    if (control.value && !nameRegexp.test(control.value)) {
        return { 'invalidEmail' : true };
    }
    return null ;
  }

  private encrypt(value: string):string {

    var key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    var iv = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  }

  /**
 *This method handle the click on the diferent buttons of federatedlogin to get the autorization code to make the login
 *
 * @param {string} idp
 * @memberof LoginComponent
 */
public getAuthCode (idp: string ): void {
  this.progreesBarService.showProgressBar();
  this._authSubscription = this._authService.getAuthCodeUrl(idp,false).subscribe({
    next: (response) => {
      if (response?.data!=="") {
        this.progreesBarService.hideProgressBar();
        localStorage.setItem("idp",idp);
      }
    },
    error: (response: string) => {
      this.progreesBarService.hideProgressBar();
      let errormessage = this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString();
      if(TranslatedTextKey.hasOwnProperty(response))
      {
        let key = (TranslatedTextKey as { [key: string]: any })[response] as string;
        errormessage=this.translate.instant(key).toString();
      }
      this.messageService.add({ severity: 'error', detail: errormessage });
    }
      });
    }

    public federatedLogin (code: string ): void {
      this.progreesBarService.showProgressBar();
      let getFederatedTokenModel = new GetFederatedTokenModel();
      getFederatedTokenModel.AuthCode=code;
      getFederatedTokenModel.idp=localStorage.getItem("idp");
      this._authSubscription = this._authService.getFederatedToken(getFederatedTokenModel).subscribe({
        next: (response) => {
          if (response?.data!=="") {
            let responseB2C:any = response.data;
            this.progreesBarService.hideProgressBar();
            window.location.href = environment.DefaultRedirect+"?idToken="+responseB2C.access_token+"&refreshToken="+responseB2C.refresh_token;
          }
        },
        error: (response: string) => {
          this.progreesBarService.hideProgressBar();
          let errormessage = this.translate.instant(TranslatedTextKey.ERROR_MESSAGE500).toString();
          if(TranslatedTextKey.hasOwnProperty(response))
          {
            let key = (TranslatedTextKey as { [key: string]: any })[response] as string;
            errormessage=this.translate.instant(key).toString();
          }
          this.messageService.add({ severity: 'error', detail: errormessage });
        }
      });

        }

  private onChangeLanguage() {
    this._onChangeLanguage = this._baseTranslateService.onChangeLanguage()
      .subscribe();
  }


  goRegisterForm() {
    if(this._userService?.userInfo?.email){
      if (this._userService) {
        this._userService.userInfo = null;
      }
    }
    this._userService.typeUser = 1;
    this.router.navigate([ROUTER_LOGIN.REGISTER.FORM]);
  }

  goBack() {
    this.router.navigate([ROUTER_LOGIN.LOGIN.FORM]);
  }
}
